module.exports = __webpack_public_path__ + "static/media/MarketingPackage.bfc2b8f9.jpg";